import {
  Graph,
  BasicInfo,
  Documents,
  History,
  Terms,
  } from './components';


export const steps = [
  {
    name: 'GRAPH',
    label: 'Συνοπτική Παρουσίαση Κατάστασης',
    Component: Graph,
    id: 0,
  },
  {
    name: 'INFO',
    label: 'Επενδυτικό Σχέδιο',
    Component: BasicInfo,
    id: 1,
  },
  {
    name: 'DOCUMENTS',
    label: 'Δικαιολογητικά',
    Component: Documents,
    id: 2,
  },
  
  {
    name: 'TERMS',
    label: 'Όροι και Προϋποθέσεις',
    Component: Terms,
    id: 3,
  },
  {
    name: 'HISTORICITY',
    label: 'Ιστορικότητα',
    Component: History,
    id: 4,
  },
  ];